export async function playRoundMedia(media: HTMLAudioElement, url: string, resume: () => Promise<void>, isCurrent: () => boolean, options: { retry?: boolean } = {}): Promise<'started' | 'blocked' | 'stale'> {
  try {
    if (!isCurrent()) return 'stale';
    await resume();
    if (!isCurrent()) return 'stale';
    if (media.getAttribute('src') !== url) media.src = url;
    else if (options.retry && (media.error || media.networkState === 3)) media.load();
    if (!isCurrent()) return 'stale';
    media.loop = true;
    await media.play();
    return isCurrent() ? 'started' : 'stale';
  } catch { return isCurrent() ? 'blocked' : 'stale'; }
}

export async function playTestTone(ctx: AudioContext): Promise<boolean> {
  try {
    if (ctx.state === 'suspended') await ctx.resume();
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.connect(gain); gain.connect(ctx.destination);
    oscillator.frequency.value = 660;
    gain.gain.setValueAtTime(0.08, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.2);
    oscillator.start(ctx.currentTime); oscillator.stop(ctx.currentTime + 0.2);
    return true;
  } catch { return false; }
}
